module.exports = __webpack_public_path__ + "assets/vdeo-back-btn-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/ai-preview/vdeo-back-btn-icon.png
// module id = 561
// module chunks = 0